// Vendors
import { useEffect, useState } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Event handlers
import { ErrorHandlers } from '../handlers/error.handlers';
// Types
import { ErrorHookType } from './types/error.hook.type';

const useErrorHook = (mappedError: AppErrorEnumeration): ErrorHookType => {
  const { loanId, callbackUrl, clearAllSessionIntervalsProcesses } = useAppContextConsumerHook();
  const [showModal, setShowModal] = useState<boolean>(false);

  const {
    handleCloseCancelApplicationModal,
    handleManageErrorButtonClick,
    handleSendErrorLog,
    handleShowCancelApplicationModal,
  } = ErrorHandlers({
    callbackUrl,
    clearAllSessionIntervalsProcesses,
    loanId,
    mappedError,
    setShowModal,
  });

  useEffect(() => {
    handleSendErrorLog();
  }, []);

  return {
    handleCloseCancelApplicationModal,
    handleManageErrorButtonClick,
    handleShowCancelApplicationModal,
    showModal,
  };
};

export { useErrorHook };
